/** Fetch a remote image URL into a File (for re-opening the crop dialog). */
export async function imageFileFromUrl(
  url: string,
  filename = 'image.jpg'
): Promise<File> {
  const response = await fetch(url, { credentials: 'include' });
  if (!response.ok) {
    throw new Error(`Failed to load image (${response.status})`);
  }
  const blob = await response.blob();
  const type = blob.type || 'image/jpeg';
  return new File([blob], filename, { type });
}
